import { useEffect, useState } from "react";
import { api, type MeResponse } from "../api";
import { navigate } from "../router";
import { ErrorCard, Loading } from "./Profile";

export function HistoryPage() {
  const [data, setData] = useState<MeResponse | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.me().then(setData).catch((e: Error) => setError(e.message));
  }, []);

  if (error) return <ErrorCard message={error} />;
  if (!data) return <Loading />;

  const games = data.recentGames as Array<{
    game_id: number;
    status: string;
    finished_at: number | null;
    winner_user_id: number | null;
    room_code: string;
    color: string;
  }>;

  return (
    <div className="screen">
      <header className="header">
        <h1>📜 تاریخچه بازی‌ها</h1>
      </header>
      <div className="card">
        {games.length === 0 && <p className="muted center">هنوز بازی‌ای نکرده‌اید.</p>}
        {games.map((g) => {
          const won = g.winner_user_id === data.user.id;
          return (
            <div key={g.game_id} className="lb-row">
              <span>{won ? "🏆" : g.status === "FINISHED" ? "❌" : "⏳"}</span>
              <span className="lb-name" dir="ltr">
                {g.room_code}
              </span>
              <span className="muted">
                {g.finished_at ? new Date(g.finished_at).toLocaleDateString("fa-IR") : "در حال انجام"}
              </span>
            </div>
          );
        })}
      </div>
      <button className="btn block" onClick={() => navigate("home")}>🏠 بازگشت</button>
    </div>
  );
}
